import { Facet } from '../../models/Facet';

export const tilesLayoutType = new Facet<{}>('tiles');
